/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IRootStoreState } from './root-store.state';

export const rootKey = 'root';

const selectRoot = createFeatureSelector<IRootStoreState>(rootKey);

export const selectLoading = createSelector(
    selectRoot,
    ({ loading }) => loading,
);
